/*
 * <sticky-atc>: small helper for the PDP sticky Add-to-cart bar.
 * Variant sync, price, image and sold-out state are handled by the theme's own product-info.js
 * (it re-renders #StickyMedia-, #StickySku-, #StickyPrice- and #StickyAddCart- on every variant change).
 * This file only adds:
 *   1. --satc-h on <html>: the bar's real height, used to lift the chat + accessibility buttons above it
 *   2. a screen-reader announcement after an add from the bar
 */
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.querySelector('.sticky-add-to-cart-wrapper');
        this.status = this.querySelector('[data-satc-status]');

        if (this.wrapper && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.setHeightVar());
          this.resizeObserver.observe(this);
        }

        // PUB_SUB_EVENTS / subscribe are top-level consts in the theme (not window properties)
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.announce(event));
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.cartUnsubscriber?.();
      }

      setHeightVar() {
        // offsetHeight is 0 while the bar is hidden; keep the last real value so the lift doesn't flicker
        const h = this.offsetHeight;
        if (h > 0) document.documentElement.style.setProperty('--satc-h', `${h}px`);
      }

      announce(event) {
        if (!this.status || !event || event.source !== 'product-form') return;
        const form = this.querySelector('form');
        const id = form?.querySelector('[name=id]')?.value;
        if (!id || String(event.productVariantId) !== String(id)) return;
        const added = (window.quickOrderListStrings?.itemAdded || '[quantity] item added').replace('[quantity]', '1');
        const title = this.querySelector('.satc__title')?.textContent.trim() || '';
        const option = this.querySelector('.satc__option')?.textContent.replace(/\s+/g, ' ').trim() || '';
        this.status.textContent = '';
        requestAnimationFrame(() => {
          this.status.textContent = [added, title, option].filter(Boolean).join(', ');
        });
      }
    }
  );
}
